import { NoteDuration } from "./NotationSerializer";
import {
    NOTE_WIDTH,
    tickToPosition
} from "../render/renderUtils";


class ScrollController {
    private static instance: ScrollController;
    private listeners:  ((n: number) => void)[] = [];
    private leftOffset = 0;
    private lastListenerId: number = 0;

    private constructor() {}
    static getInstance() {
        if (!ScrollController.instance) {
            ScrollController.instance = new ScrollController();
        }
        return ScrollController.instance;
    }
    update(n: number) {
        this.listeners.forEach(l => l(n));
        this.leftOffset = n;
    }

    clearListeners() {
        this.listeners = [];
    }

    drop(id: number) {
        this.listeners = this.listeners.filter((_, i) => i !== id);
    }

    listen(l: (n: number) => void): number {
        this.lastListenerId++;
        this.listeners[this.lastListenerId] = l;
        return this.lastListenerId;
    }

    getLeftOffset() {
        return this.leftOffset;
    }
}

export type CaretScrollCallbackParams = {
    ticks: number,
    style: { left: string }
};
export type CaretScrollCallback = (n: CaretScrollCallbackParams) => void;

class CaretController {
    readonly scrollController?: ScrollController;
    private caretUpdateListeners: CaretScrollCallback[] = [];
    private caretPosition: number = 0;
    private resolution: NoteDuration;
    private ppq: number;
    private lastListenerId: number = 0;
    private zoomFactor;

    constructor({
        scrollController,
        resolution,
        ppq,
        zoomFactor
    }: {
        scrollController?: ScrollController,
        resolution: NoteDuration,
        ppq: number,
        zoomFactor: number

    }) {
        this.scrollController = scrollController;
        this.resolution = resolution;
        this.ppq = ppq;
        this.zoomFactor = zoomFactor;
    }

    private toInt(s: string) : number {
        return Number.parseInt(s.replace('px', ''), 10);
    }

    private getPianoRollHeaderWidth(styles : CSSStyleDeclaration) : number {
        // FIXME:    We can't simply do styles.getPropertyValue('--piano-roll-header-width')
        // because it returns a calc(...) expression, uncomputed.
        // This hack "recomputes" the same value but is not "synched" with the CSS.
        return this.toInt(styles.getPropertyValue('--note-width'))
            + this.toInt(styles.getPropertyValue('--keybed--note-label-width--pianoroll'))
            - 2;
    }

    scrollToTick(ticks: number) {
        // the caret sequencer will send /16 of the ppq
        if (ticks === this.caretPosition) return;
        // FIXME: find with viewport width and /2 it to set the center (toleranceGap).
        // const toleranceGap = 200;
        this.caretPosition = ticks;
        // FIXME: FML this is horrible.
        // FIXME: use CSS.VAR
        const styles = window.getComputedStyle(document.body);
        const keybedWidth = this.getPianoRollHeaderWidth(styles);

        const p = tickToPosition(NOTE_WIDTH, this.zoomFactor, ticks) + keybedWidth;
        const px = p + 'px';

        this.caretUpdateListeners.forEach(l => l({ ticks: ticks, style: { left: px } }));
        this.scrollController?.update(p - 200);
    }

    /**
     *
     * @param f A CSS expression to be set as the 'left' property of the caret.
     */
    register(f : CaretScrollCallback) : number {
        this.lastListenerId++;
        this.caretUpdateListeners[this.lastListenerId] = f;
        return this.lastListenerId;
    }

    clearListeners() {
        this.caretUpdateListeners = [];
    }

    unregister(id: number) {
        this.caretUpdateListeners = this.caretUpdateListeners.filter((_, i) => i !== id);
    }

    setZoomFactor(zoomFactor: number) {
        this.zoomFactor = zoomFactor;
        this.scrollToTick(this.caretPosition);
    }

    getCaretPosition() {
        return this.caretPosition;
    }
}

export {
    ScrollController,
    CaretController
};